import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { GWPandLoyaltyGeoSettings } from 'src/scripts/globals';
import { InitialUrlSearchParams } from 'src/scripts/utils/environment';

const AccessBenefitsGrid = () => {
  const [region, setRegion] = useState<'domestic' | 'intl'>('domestic');
  const customerInfo = window.getCustomerInfo?.();
  const isCustomer = customerInfo?.isCustomer ?? false;

  useEffect(() => {
    const updateRegion = async () => {
      const loyaltySettings = await GWPandLoyaltyGeoSettings();
      if (loyaltySettings.shouldRenderLoyaltyWidgetForINTL) setRegion('intl');
    };
    updateRegion();
    const urlParams = InitialUrlSearchParams;
    const tier = urlParams.get('tier');
    const tierCheck = tier && tier?.startsWith('tier');
    const loyaltyGridWebviewContainer = document.querySelector('.loyalty-grid-webview');
    if (loyaltyGridWebviewContainer && tier && tierCheck) {
      loyaltyGridWebviewContainer.classList.add(tier);
    }
  }, []);

  return (
    <div className="benefits-chart">
      {isCustomer && <div className="benefits-outline"></div>}
      <div className="grid-container header">
        <div className="header-div"></div>
        <div className="header-div">
          <img
            src="https://cdn.shopify.com/s/files/1/2185/2813/files/aloaccess_vip.png?v=1727167810"
            className="vip"
            alt="vip-logo"
          />
          <span className="points-header">0-299 PTS</span>
        </div>
        <div className="header-div">
          <img
            src="https://cdn.shopify.com/s/files/1/2185/2813/files/aloaccess_alist.png?v=1727167849"
            className="alist"
            alt="alist-logo"
          />
          <span className="points-header">300-999 PTS</span>
        </div>
        <div className="header-div">
          <img
            src="https://cdn.shopify.com/s/files/1/2185/2813/files/aloaccess_allaccess.png?v=1727167829"
            className="allaccess"
            alt="allaccess-logo"
          />
          <span className="points-header">1000+ PTS</span>
        </div>
      </div>
      <div className={`grid-container content ${region === 'domestic' ? 'domestic' : 'intl'}`}>
        <div className="desc">Welcome Gift</div>
        <div className="circle-container">
          <span className="circle"></span>
        </div>
        <div className="circle-container">
          <span className="circle"></span>
        </div>
        <div className="circle-container">
          <span className="circle"></span>
        </div>

        {region === 'domestic' ? (
          <>
            <div className="desc">Birthday Gift</div>
            <div className="circle-container">
              <span className="circle"></span>
            </div>
            <div className="circle-container">
              <span className="circle"></span>
            </div>
            <div className="circle-container">
              <span className="circle"></span>
            </div>
          </>
        ) : null}

        <div className="desc">Early access to Drops</div>
        <div className="circle-container">
          <span className="circle"></span>
        </div>
        <div className="circle-container">
          <span className="circle"></span>
        </div>
        <div className="circle-container">
          <span className="circle"></span>
        </div>

        <div className="desc">Member-Only Sales</div>
        <div className="circle-container">
          <span className="circle"></span>
        </div>
        <div className="circle-container">
          <span className="circle"></span>
        </div>
        <div className="circle-container">
          <span className="circle"></span>
        </div>

        <div className="desc">Free 2-Day Shipping</div>
        <div className=""></div>
        <div className="circle-container">
          <span className="circle"></span>
        </div>
        <div className="circle-container">
          <span className="circle"></span>
        </div>

        <div className="desc">Priority Access to Drops</div>
        <div className=""></div>
        <div className="circle-container">
          <span className="circle"></span>
        </div>
        <div className="circle-container">
          <span className="circle"></span>
        </div>

        <div className="desc">A-list Events + Classes</div>
        <div className=""></div>
        <div className="circle-container">
          <span className="circle"></span>
        </div>
        <div className="circle-container">
          <span className="circle"></span>
        </div>

        <div className="desc">Surprise Reward Days</div>
        <div className=""></div>
        <div className="circle-container">
          <span className="circle"></span>
        </div>
        <div className="circle-container">
          <span className="circle"></span>
        </div>

        <div className="desc">
          Priority Customer
          <br />
          Service
        </div>
        <div className=""></div>
        <div className="circle-container">
          <span className="circle"></span>
        </div>
        <div className="circle-container">
          <span className="circle"></span>
        </div>
        <div className="desc">Invite-only Experiences</div>
        <div className=""></div>
        <div className=""></div>
        <div className="circle-container">
          <span className="circle"></span>
        </div>
        <div className="desc">
          Unlock Private
          <br />
          Instagram Access
        </div>
        <div className=""></div>
        <div className=""></div>
        <div className="circle-container">
          <span className="circle"></span>
        </div>
      </div>
    </div>
  );
};

export default AccessBenefitsGrid;

const mountNode = document.querySelector('[react-render-target="access-benefits-grid"]');
mountNode
  ? ReactDOM.render(<AccessBenefitsGrid />, mountNode)
  : console.warn('missing render target: AccessBenefitsGrid');
